import React, { useRef } from "react";
import classNames from "classnames";
import Form from "theme/components/atoms/Form/Form";
import { PrimaryButton } from "theme/components/atoms/Button";
import Spacer from "theme/components/atoms/Layout/Spacer";
import useFocusOnMount from "theme/components/helpers/a11y/useFocusOnMount";
import { ErrorAlert } from "theme/components/molecules/Alert";

const BaseAddToCart = ({
  appearance,
  message,
  addToCart,
  label,
  state,
  quantity,
  actions,
}) => {
  const errorRef = useRef();
  useFocusOnMount(Boolean(message), errorRef);

  return (
    <Form
      className={classNames("add-to-cart", {
        [`add-to-cart--${appearance}`]: appearance,
      })}
      onValidSubmit={(data) => {
        return addToCart(data);
      }}
    >
      <div className="add-to-cart__main">
        <link itemProp="availability" href="http://schema.org/InStock" />
        {quantity && <div className="add-to-cart__quantity">{quantity}</div>}
        <div className="add-to-cart__button">
          <PrimaryButton state={state} type="submit" size="big">
            {label}
          </PrimaryButton>
        </div>
        {actions !== false && (
          <div className="add-to-cart__actions">{actions}</div>
        )}
      </div>
      {message && (
        <>
          <Spacer size="1" />
          <div className="add-to-cart__error" ref={errorRef} tabIndex="-1">
            <ErrorAlert>{message}</ErrorAlert>
          </div>
        </>
      )}
    </Form>
  );
};

export default BaseAddToCart;
